module.exports = __webpack_public_path__ + "assets/img/btn-detail-387a9b6e.png";